// import './lib'
import 'babel-polyfill'
// import '@babel/polyfill'

import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
// import { sync } from 'vuex-router-sync'
import store from './store'
import router from './router'

import VueClipboard from 'vue-clipboard2'
// import JsPdf from 'jspdf'
import axios from 'axios'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import '@/components/dropzone-custom.css'
import dropzoneComp from '@/components/dropzoneComp'
import dropzoneCompV2 from '@/components/dropzoneCompV2'
import dateInput from '@/components/dateInput'
import dateTimeInput from '@/components/dateTimeInput'
import personInput from '@/components/personInput'
import optionInput from '@/components/optionInput'
import CurrencyInput from '@/components/currencyinput'
import BookDt from '@/components/book/bookDT'

VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
// Vue.use(JsPdf)


Vue.component('dropzone-comp', dropzoneComp)
Vue.component('dropzone-v2', dropzoneCompV2)
Vue.component('date-input', dateInput)
Vue.component('date-input', dateInput)
Vue.component('date-time-input', dateTimeInput)
Vue.component('person-input', personInput)
Vue.component('option-input', optionInput)
Vue.component('currency-input', CurrencyInput)
Vue.component('book-dt', BookDt)

import directivePermission from '@/directive/permission'
import directiveNotPermission from '@/directive/notpermission'
Vue.directive('permission', directivePermission)
Vue.directive('notpermission', directiveNotPermission)

import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
Vue.filter('numFormat', numFormat(numeral));

import DateFilter from './filters/date'
Vue.filter('date', DateFilter.fdate)
Vue.filter('date1', DateFilter.fdate1)
Vue.filter('datetime', DateFilter.fdatetime)
Vue.filter('time', DateFilter.ftime)
Vue.filter('dateEng', DateFilter.fdateEng)
Vue.filter('dateEng1', DateFilter.fdateEng1)
Vue.filter('datetimeEng', DateFilter.fdatetimeEng)
Vue.filter('datedif', DateFilter.fdatedif)
Vue.filter('datedif2', DateFilter.fdatedif2)
Vue.filter('currency', DateFilter.currency)

import PersonFilter from './filters/person'
Vue.filter('depName', PersonFilter.depName)
Vue.filter('empName', PersonFilter.empName)
Vue.filter('empEmail', PersonFilter.empEmail)
Vue.filter('empPRCode', PersonFilter.empPRCode)
Vue.filter('empFullName', PersonFilter.empFullName)

import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

import browserDetect from 'vue-browser-detect-plugin'
Vue.use(browserDetect)

Vue.prototype.$http = axios
Vue.config.productionTip = true

// console.log('env', JSON.stringify(process.env))
// sync(store, router)

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')